import Swiper from 'swiper';
import { Navigation, Pagination, FreeMode, Autoplay } from 'swiper/modules';
import { fetchAPI } from "packs/api";
window.Swiper = Swiper; // Assign Swiper to the window object to make it globally accessible
Swiper.use([Navigation, Pagination, FreeMode, Autoplay]); // So that swiper can use pagination, autoplay - without it we cannot use

document.addEventListener("DOMContentLoaded", () => {
  if (window.location.href.includes("moderation")) {
    return;
  }
  setUpSwiper();

  let widgetDropdown = document.getElementById("selected-widget-category");
  let widgetDropdownContent = document.getElementById("widget-dropdown-content");

  if (widgetDropdown && widgetDropdownContent) {
    widgetDropdown.onclick = () => {
      widgetDropdown.classList.toggle("open");
      widgetDropdown.classList.contains("open") ? slideDownContent(widgetDropdownContent) : slideUpContent(widgetDropdownContent);
    };

    document.addEventListener("click", (event) => {
      if (!widgetDropdown.contains(event.target) && widgetDropdown.classList.contains("open")) {
        slideUpContent(widgetDropdownContent);
        widgetDropdown.classList.remove("open");
      }
    });
  }

  
    let widgetFilters = document.querySelectorAll(".change-widget-filter");
  
    if (widgetFilters) {
      widgetFilters.forEach(filter => {
        filter.addEventListener("click", function (event) {
          // let filterValue = event.target.dataset.filter;
          let targetElement = event.target.closest(".change-widget-filter");
          let filterValue = targetElement ? targetElement.getAttribute("data-filter") : null;
          let fetchParams = { timeframe: filterValue };
          let merchantWidget = document.getElementById("merchant-widget");
          let groupWidget = document.getElementById("group-widget");
          if (merchantWidget) {
            fetchParams.resource_type = "merchant";
            fetchParams.resource_id = merchantWidget.dataset.merchant;
          } else if (groupWidget) {
            fetchParams.resource_type = "group";
            fetchParams.resource_id = groupWidget.dataset.group;
          }
          fetchAPI("/get_deal_widget_data", "GET", fetchParams, "script").then(response => {
            setUpSwiper();
            let newFilter = event.target.closest(".change-widget-filter");
            let filterText = newFilter.textContent.trim();
            let selectedWidgetCategory = document.getElementById("selected-widget-category");
            selectedWidgetCategory.querySelector("span").innerHTML = `${filterText}`;
            widgetFilters.forEach(f => f.classList.remove("!text-primary", "text-primary-text-light", "dark:text-primary-text-dark"));
            newFilter.classList.add("!text-primary", "text-primary-text-light", "dark:text-primary-text-dark");
            let widgetDropdownContent = document.getElementById("widget-dropdown-content");
            widgetDropdownContent.classList.add("hidden");
          }).catch(error => {
            console.error("Failed to fetch data:", error);
          });
        });
      });
    }
    
});

function setUpSwiper() {
  let widgetScrollContainer = document.getElementById("widget-scroll-container");
  if (!widgetScrollContainer) return;
  if (widgetScrollContainer.swiper) widgetScrollContainer.swiper.destroy(true, false);

  let swiperHomepageWidget = new Swiper('#widget-scroll-container', {
    slidesPerView: 1.2,
    spaceBetween: 10,
    pagination: false,
    freeMode: true,
    freeModeSticky: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      470: {
      slidesPerView: 2,
        freeMode: true,
        freeModeSticky: false,
      },
      769: {
        slidesPerView: 3,
        freeMode: true,
        freeModeSticky: false,
      },
      1280: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        freeMode: false,
      },
    },
  });
  swiperHomepageWidget.update();
  swiperHomepageWidget.slideTo(0);
}
